import "./Animal.module.css";
import Header from "@/reusable_sections/Header";
import AnimalWelfareHero from "./sections/AnimalWelfareHero";
import Awareness from "./sections/Awareness";
import Footer from "@/reusable_sections/Footer";
export default function AnimalPage() {
  return <div>
      <Header />
      <AnimalWelfareHero />
      <Awareness />
      <Footer />
    </div>;
}